
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class AlertRequestTypeNotAvailable extends React.Component {

    static propTypes = {
      onCancel: PropTypes.func,
      onGoToTemplates: PropTypes.func,
      isOpen: PropTypes.bool,
      requestTypeName: PropTypes.string
    }

    render() {
      return (
        <Modal dialogClassName='confirm-cancel-save-eoc-template-dialog' show={this.props.isOpen} size='sm'>
          <Modal.Header>
            <Modal.Title style={{fontWeight: 'bold'}}>Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              We don't find any template associated with the request type <b>{this.props.requestTypeName}</b> in this project. Go to the project's Templates page to add one.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div style={{float: 'left'}}>
              <button className='btn btn-primary btn-siteone-default' onClick={this.props.onCancel}>Cancel</button>
              <button className='btn btn-primary btn-siteone' style={{marginLeft: 10}} onClick={this.props.onGoToTemplates}>Go to Templates</button>
            </div>
          </Modal.Footer>
        </Modal>
      );
    }
}

export default AlertRequestTypeNotAvailable;



// WEBPACK FOOTER //
// ./src/Punch-List/Components/alert-request-type-not-available.js